// Path: src/components/admin/AdminRoutes.tsx
// Added /admin/referrals route for AdminReferral component
// Path: src/components/admin/AdminRoutes.tsx
// Updated to add the /admin/live-support route for the new LiveSupport component.

import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AdminDashboard from "./AdminDashboard";
import VerifyUsers from "./Users/VerifyUsers";
import UserDetails from "./Users/UserDetails";
import { OrdersList, OrderDetails } from "./Orders";
import AdminReferral from "./aReferral";
import AdminEvaluation from "./aEvaluationS";
import LiveSupport from "./LiveSupport"; // IMPORTED: The new component for live chat
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import ErrorBoundary from "../dev/utils/ErrorBoundary";
import { Typography, Button } from "antd";
import { Link } from "react-router-dom";

const { Title } = Typography;

const AdminRoutesContainer = styled.div`
  background: linear-gradient(to bottom, #fff5e6, #fff);
  padding: 20px;
  animation: fadeIn 1.5s ease-in;

  @media (max-width: 768px) {
    padding: 10px;
    .ant-btn,
    .ant-input {
      font-size: 14px !important;
    }
  }
`;

const FallbackContainer = styled.div`
  text-align: center;
  padding: 40px;
`;

const AdminRoutes: React.FC = () => {
  const location = useLocation();
  // console.log("AdminRoutes rendering - Current location:", location.pathname);

  return (
    <AdminRoutesContainer className="admin-routes">
      <Helmet>
        <title>Admin Dashboard - One Light System OLS</title>
        <meta
          name="description"
          content="Manage users and orders in the One Light System OLS admin panel for Sun Light Meditation education."
        />
        <meta
          name="keywords"
          content="OLS Admin Dashboard, Sun Light Meditation, OLS Management, Light Civilization"
        />
        <link rel="canonical" href="https://www.olsme.com/admin" />
      </Helmet>
      <ErrorBoundary>
        <Routes>
          <Route
            path="users/all"
            element={
              <>
                {/* {console.log("Matched route: /admin/users/all")} */}
                <AdminDashboard />
              </>
            }
          />
          <Route
            path="users/verify"
            element={
              <>
                {/* {console.log("Matched route: /admin/users/verify")} */}
                <VerifyUsers />
              </>
            }
          />
          <Route
            path="user/:id"
            element={
              <>
                {/* {console.log("Matched route: /admin/user/:id")} */}
                <UserDetails />
              </>
            }
          />
          <Route
            path="evaluation/:userId"
            element={
              <>
                {/* {console.log("Matched route: /admin/evaluation/:userId")} */}
                <AdminEvaluation />
              </>
            }
          />
          <Route
            path="evaluation"
            element={
              <>
                {/* {console.log("Rendering fallback for /admin/evaluation")} */}
                <FallbackContainer>
                  <Title level={3}>Select a User to Evaluate</Title>
                  <p>Please choose a user from the verification page to proceed with evaluation.</p>
                  <Link to="/admin/users/verify">
                    <Button type="primary">Go to Verify Users</Button>
                  </Link>
                </FallbackContainer>
              </>
            }
          />
          <Route
            path="referrals"
            element={
              <>
                {/* {console.log("Matched route: /admin/referrals")} */}
                <AdminReferral />
              </>
            }
          />
          <Route
            path="orders"
            element={
              <>
                {/* {console.log("Matched route: /admin/orders")} */}
                <OrdersList />
              </>
            }
          />
          <Route
            path="orders/:orderId"
            element={
              <>
                {/* {console.log("Matched route: /admin/orders/:orderId")} */}
                <OrderDetails />
              </>
            }
          />
          
          {/* --- NEW LIVE SUPPORT ROUTE ADDED --- */}
          <Route
            path="live-support"
            element={
              <>
                {/* {console.log("Matched route: /admin/live-support")} */}
                <LiveSupport />
              </>
            }
          />

          <Route path="*" element={<div>Route not found in AdminRoutes - Path: {location.pathname}</div>} />
        </Routes>
      </ErrorBoundary>
    </AdminRoutesContainer>
  );
};

export default AdminRoutes;